import { useReimbursementRequestContext } from "../../../Contexts/ReimbursementRequestContext";
import UploadPoliceReport from "./UploadPoliceReport";
import UploadChargeSlip from "./UploadChargeSlip";
import UploadDentalCert from "./UploadDentalCert";
import UploadOpticalRx from "./UploadOpticalRx";
import UploadOPMedRx from "./UploadOPMedRx";
import UploadMedCert from "./UploadMedCert";
import UploadModal from "./UploadModal";
import UploadSOA from "./UploadSOA";
import UploadOR from "./UploadOR";
import Camera from "./Camera";

function Upload() {
  const {
    formData,
    setFormData,
    setErrorField,
    uploadField,
    setShowUploadModal,
    showUploadModal,
    setIsCameraOpen,
    isCameraOpen
  } = useReimbursementRequestContext();

  const handleUploadSuccess = (file) => {
    if (file) {
      let newForm = {
        ...formData,
        [uploadField]: file,
      };
      setFormData(newForm);
    }
  };

  const handleCloseUpload = () => {
    setShowUploadModal(false);
  };

  const handleOpenCamera = () => {
    setIsCameraOpen(true);
  };

  const handleCloseCamera = () => {
    setIsCameraOpen(false);
  };

  const handleCaptureComplete = (file) => {
    if (file.size > 1000000) {
      setErrorField(uploadField);
    } else {
      setErrorField("");
    }
    let newForm = {
      ...formData,
      [uploadField]: file,
    };
    setFormData(newForm);
    setShowUploadModal(false);
  };

  const handleSetErrorField = (field) => {
    setErrorField(field);
  };

  let medCertUpload = null;
  let soaUpload = null;
  let policeReportUpload = null;
  let opticalRxUpload = null;
  let dentalCertUpload = null;
  let opMedicineRxUpload = null;

  if (formData.claimType === "Out Patient (OP)") {
    medCertUpload = <UploadMedCert/>;
    policeReportUpload = <UploadPoliceReport/>;
  } else if (formData.claimType === "In Patient (IP)") {
    medCertUpload = <UploadMedCert/>;
    soaUpload = <UploadSOA/>;
    policeReportUpload = <UploadPoliceReport/>;
  } else if (formData.claimType === "OP Medicine") {
    opMedicineRxUpload = <UploadOPMedRx/>;
  } else if (formData.claimType === "Optical") {
    opticalRxUpload = <UploadOpticalRx/>;
  } else if (formData.claimType === "Dental") {
    dentalCertUpload = <UploadDentalCert/>;
  }

  return (
    <div className="p-4">
      <p className="text-[#1F2328] text-xl font-bold mb-1">
        {formData.claimType} requirements
      </p>
      <p className="text-[#60656D] mb-4">
        Prepare your document for attachment. Accepted formats: PDF, PNG, JPG
        (max 1MB)
      </p>
      <UploadChargeSlip/>
      <UploadOR/>
      {medCertUpload}
      {soaUpload}
      {policeReportUpload}
      {opticalRxUpload}
      {dentalCertUpload}
      {opMedicineRxUpload}
      <UploadModal
        open={showUploadModal}
        uploadField={uploadField}
        onClose={handleCloseUpload}
        onUploadSuccess={handleUploadSuccess}
        onOpenCamera={handleOpenCamera}
        onSetErrorField={handleSetErrorField}
      />
      <Camera
        open={isCameraOpen}
        onClose={handleCloseCamera}
        onComplete={handleCaptureComplete}
      />
    </div>
  );
}

export default Upload;